import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Box } from '@mui/material';

import { Field } from '@components';

import styles from './addServicePointAddressModal.style';

export const AddressForm = ({ defaultValues, onSubmit, loading }) => {
  const methods = useFormContext();

  useEffect(() => {
    methods.reset(defaultValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues]);

  return (
    <form id="edit-address-form" onSubmit={methods.handleSubmit(onSubmit)}>
      <Box sx={{ ...styles.fieldsWrapper }}>
        <Box sx={{ ...styles.row }}>
          <Field
            isColumn
            isRequired
            label="Street Name:"
            name="streetAddress"
            control={methods.control}
            disabled={loading}
          />
          <Field
            isColumn
            label="Street Number:"
            name="streetNumber"
            control={methods.control}
            disabled={loading}
          />
        </Box>
        <Box sx={{ ...styles.row }}>
          <Field
            isColumn
            isRequired
            label="City:"
            name="locality"
            control={methods.control}
            disabled={loading}
          />
          <Field
            isColumn
            isRequired
            label="Postal Code:"
            name="postalCode"
            control={methods.control}
            disabled={loading}
          />
        </Box>
        <Box sx={{ ...styles.row }}>
          <Field
            isColumn
            isRequired
            label="Area:"
            name="region"
            control={methods.control}
            disabled={loading}
          />
          <Field
            isColumn
            isRequired
            label="Country:"
            name="country"
            control={methods.control}
            disabled={loading}
          />
        </Box>
      </Box>
    </form>
  );
};

export default AddressForm;
